<template>
  <div class="main">
    <div class="title">Kyrgyz Language Dialogues</div>
    Below is a video dialogue series aimed for beginner students of the Kyrgyz language. Each dialogue is based on a real life everyday situation and should be helpful for getting started with the language. This resource is based on a Russian language video series created by Til club with the help of the Soros foundation. The original playlist can be found <a href="https://www.youtube.com/playlist?list=PL735lKtYrX1XgWra0PfR607h-FAO8deYU">here</a>.
    <div class="grid">
      <div class="tile" :key="dialogue.id" @click="loadDialogue(dialogue.id)" v-for="dialogue in dialogues">
        
        {{dialogue.index}}.
        {{dialogue.title}}
      
        </div>
    </div>
  </div>
</template>


<script>
import Dialogues from "@/views/dialogues.json";
export default {
  computed: {
    dialogues() {
      return Dialogues;
    }
  },
  methods: {
    loadDialogue(id) {
      this.$router.push({ path: `/video/${id}` });
      console.log("test");
    }
  }
};
</script>


<style lang="scss">
$secondary_color: #084696;

.main {
  .title {
    font-size: 30px;
  }

  .grid {
    padding: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .tile {
      cursor: pointer;
      width: 250px;
      height: 100px;
      background: #ddd;
      border: 1px solid;
      margin: 10px;
      padding: 10px;
      font-size: 20px;

      &:hover {
        background: $secondary_color;
        color: white;
      }
    }
  }
}
</style>
